import { gql } from '../../generated'

export const UPSERT_USER_PHONE_STATUS_MUTATION =
  gql(`mutation UpsertUserPhoneStatus($obj: IntegratedPhoneUsersInsertInput!) {
  insertIntegratedPhoneUsersOne(onConflict: {constraint: integrated_phone_users_company_guid_user_guid_key, updateColumns: [updatedAt, isAvailable, identity]}, object: $obj) {
    __typename
  }
}`)
